import React, { useMemo } from 'react'

import { useProfile } from '@/hooks'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

export function ComboboxReports(props) {
  const profile = useProfile()

  const reports = useMemo(() => {
    if (profile.isCustomer) {
      return [
        { value: 3, label: 'Títulos em aberto' },
        { value: 6, label: 'Estoque' },
      ]
    }

    if (profile.isRepresentative) {
      return [
        { value: 1, label: 'Ranking de Produtos' },
        { value: 3, label: 'Títulos em aberto' },
        { value: 4, label: 'Pedidos Faturados' },
        { value: 5, label: 'Comissões' },
        { value: 6, label: 'Estoque' },
      ]
    }

    return []
  }, [profile])

  return (
    <Autocomplete
      {...props}
      options={reports}
      id="combo-box-reports"
      noOptionsText="Nenhuma consulta cadastrada"
      disableClearable
      getOptionLabel={(option) => option.label}
      getOptionDisabled={(option) => option.disabled}
      style={{ width: 400 }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label="Escolha a consulta"
          variant="filled"
          autoComplete="off"
        />
      )}
    />
  )
}
